import React, { useRef } from 'react';
import PropTypes        from 'prop-types';
import classNames       from 'classnames';
import { Link }         from 'react-router-dom';

import useMobileMenu    from './useMobileMenu';
import Button           from '../Button'

import Icons            from '../../../assets/svg/icons';
import Logo             from '../../../assets/images/logo_black.png';

import config           from '../../../../etc/config.json';


import styles           from './MobileMenu.styl';

function MobileMenu(props) {
    const {
        className
    } = props;

    const menuRef = useRef()

    const {
        handleOpen,
        handleClose,
        isOpen
    } = useMobileMenu(menuRef);


    return  (
        <>
            <div
                className = {classNames(styles.MobileMenu, className)}
                onClick   = {handleOpen}
            >
                <Icons.Burger />
            </div>
            {isOpen
                ? <div className={styles.cover} />
                : null
            }
            <div
                ref       = {menuRef}
                className = {classNames(styles.menuBlock, {
                    [styles.opened]: isOpen
                })}
            >
                <div className={styles.menuHeader}>
                    <Link to='/'>
                        <img
                            src       = {Logo}
                            className = {styles.logo}
                        />
                    </Link>
                    <Icons.Close
                        className = {styles.cross}
                        onClick   = {handleClose}
                    />
                </div>
                <div className={styles.menu}>
                    <Link
                        to        = '/'
                        className = {styles.menuLink}
                    >
                        Features
                    </Link>
                    <Link
                        to        = '/'
                        className = {styles.menuLink}
                    >
                        Opportunities
                    </Link>
                    <Link
                        to        = '/'
                        className = {styles.menuLink}
                    >
                        Revolutionary
                    </Link>
                    <Link
                        to        = '/'
                        className = {styles.menuLink}
                    >
                        Potential
                    </Link>
                    <Link
                        to        = '/'
                        className = {styles.menuLink}
                    >
                        Setup
                    </Link>
                    <Link
                        to        = '/'
                        className = {styles.menuLink}
                    >
                        Availability
                    </Link>
                    <Link
                        to        = '/contacts'
                        className = {styles.menuLink}
                    >
                        Contact Us
                    </Link>
                    <Link
                        to        = '/partners'
                        className = {styles.menuLink}
                    >
                        Our Partners
                    </Link>
                </div>
                <div className={styles.bottomBlock}>
                    <div className={styles.buttons} >
                        <Link to = '/create-account' className={styles.buttonLink}>
                            <Button
                                className = {styles.button}
                                color     = 'filled'
                            >
                                Start free trial
                            </Button>
                        </Link>
                        <a
                            href      = {config.loginUrl}
                            className = {styles.loginButton}
                            color     = 'secondary'
                            target    = '_blank' rel="noreferrer"
                        >
                            Login
                        </a>
                    </div>
                    {isOpen
                        ? 
                        <div className={styles.socials}>
                            <a className={styles.fbLink}>
                                <Icons.FbGrey />
                            </a>
                            <a>
                                <Icons.InstaGrey />
                            </a>
                        </div>
                        : null
                    }
                </div>
            </div>
        </>
    );
}

MobileMenu.propTypes = {
    className : PropTypes.string
};

MobileMenu.defaultProps = {
    className : ''
};

export default MobileMenu;
